export default "__VITE_ASSET__BWMX4D5u__"